module.exports = __webpack_public_path__ + "./img/Autopartes-del-Sur-logoNew.f27706924d4b1d884ec9238676a56414.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Autopartes-del-Sur-logoNew.png
// module id = ./src/assets/img/Autopartes-del-Sur-logoNew.png
// module chunks = 6